// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__ntfFO","child":"Layout_child__0zV-E","header":"Layout_header__JQdXx","footer":"Layout_footer__lMQIg"};